/**
 * BIC Corporate-Identity-Farben (aus CI-Vorlage.xlsx), für Excel-Exporte (Regel-Import-Vorlage,
 * Check-Report-Exporte). ARGB-Format (Alpha vorangestellt), wie von ExcelJS erwartet.
 */
export const CI_COLORS = {
  darkBlue: 'FF042E3F',
  turquoise: 'FF069999',
  turquoiseLight: 'FF56D7DF',
  orange: 'FFFF7F00',
  lightGray: 'FFF1F1F1',
  white: 'FFFFFFFF',
  darkText: 'FF1D1E1F',
  /** Nicht Teil der CI-Palette; für „nicht bestanden"-Werte in Berichtstabellen. */
  red: 'FFFF0000',
  /** Nicht Teil der CI-Palette; für „unbekannt"-Werte (z. B. nicht relevante Datei) in Berichtstabellen. */
  gray: 'FF6B6B6B',
} as const;
